import { Tabs, TabsProps } from 'antd';
import PendingFilterList from './Pending/FilteredList';
// import { CustomerServiceOutlined } from "@ant-design/icons"
import styles from './style.css';
import HoldFilterList from './Hold/FilteredList';
import ProcessFilterList from './Process/FilteredList';
import CompletedFilterList from './Completed/FilteredList';
import { useContext, useState } from 'react';
import { createContext } from 'react';

interface ContextProps {
  reload?: any;
  setReload?: any;
  autopayFalseCurrentTab: string;
  setAutopayFalseCurrentTab: any;
}

const AutoPayFalseTabsContext = createContext<ContextProps>({
  autopayFalseCurrentTab: '1pending',
  setAutopayFalseCurrentTab: () => { },
});


export const useAutoPayFalseTabsContext = () => {
  return useContext(AutoPayFalseTabsContext);
};
function AutoPayFalseTabs() {
  const [reload, setReload] = useState(false);
  const [autopayFalseCurrentTab, setAutopayFalseCurrentTab] = useState('1pending');

  // Handler for when the tab changes
  const onTabChange = (key: string) => {
    setAutopayFalseCurrentTab(key);
  };

  const items: TabsProps['items'] = [
    {
      key: '1pending',
      label: 'Auto Pay False',
      children: <PendingFilterList />,
    },
    {
      key: '2hold',
      label: 'Hold',
      children: <HoldFilterList />,
    },
    {
      key: '3process',
      label: 'Process',
      children: <ProcessFilterList />,
    },
    {
      key: '4completed',
      label: 'Presentment Status',
      children: <CompletedFilterList />,
    },
  ];


  return (
    <AutoPayFalseTabsContext.Provider
      value={{ reload, setReload, autopayFalseCurrentTab, setAutopayFalseCurrentTab }}
    >
      <div style={{ marginTop: '2px' }}>
        <Tabs
          className={styles}
          defaultActiveKey={'1pending'}
          centered
          tabPosition="top"
          type="card"
          items={items}
          onChange={onTabChange} // Add the onChange handler here
        ></Tabs>
      </div>
    </AutoPayFalseTabsContext.Provider>
  );
}

export default AutoPayFalseTabs;
